import { Box, Notification } from "@mantine/core";
import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import LoginContext from "../../context/LoginContext";

export default function Layout() {
  const { globalAlert, setGlobalAlert } = useContext(LoginContext);

  // ✅ Auto-hide like Snackbar
  useEffect(() => {
    if (globalAlert?.open) {
      const timer = setTimeout(() => {
        setGlobalAlert((prev) => ({ ...prev, open: false }));
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [globalAlert?.open, setGlobalAlert]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar />

      <Box style={{ minHeight: "80vh" }}>
        <Outlet />
      </Box>

      <Footer />

      {/* ✅ Global Alert (Mantine) */}
      {globalAlert?.open && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 9999,
            maxWidth: "400px",
          }}
        >
          <Notification
            color={
              globalAlert.severity === "success"
                ? "green"
                : globalAlert.severity === "error"
                ? "red"
                : globalAlert.severity === "warning"
                ? "yellow"
                : "blue"
            }
            title={globalAlert.title}
            onClose={() =>
              setGlobalAlert((prev) => ({ ...prev, open: false }))
            }
            withCloseButton
          >
            {globalAlert.message}
          </Notification>
        </div>
      )}
    </Box>
  );
}